import React, { useEffect, useState} from "react";
import { Container, Image, Row, Col, Button, Form, InputGroup} from "react-bootstrap";
import CustomCard from '../Components/Card';
import Author from '../assests/sb.jpg';
import { db } from "../firebase";
import { getDocs, collection, doc, getDoc, orderBy, query } from "firebase/firestore";
import "./App.css";
import { useNavigate } from "react-router-dom";
import TopicBox from "../Components/TopicBox";
import { FaSearch, FaArrowUp } from 'react-icons/fa';

function Home() {
  const [allBlogs, setAllBlogs] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [popblogs, setPopBlogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [featuredArticle, setFeaturedArticle] = useState(null);
  const[selectCategory, setSelectedCategory] = useState('Others')
  const [searchTerm, setSearchTerm] = useState('');
  const [showBackToTop, setShowBackToTop] = useState(false);
  const blogsPerPage = 3;
  const navigate = useNavigate();
  const featuredId = "UWe68fT5vhDGWzRaC9RD";

  
  const getContent = (blog) => blog.postEn || blog.post || "";

  const calculateReadingTime = (text) => {
    const wordsPerMinute = 200;
    const words = (text || "").split(' ').length;
    const minutes = Math.ceil(words / wordsPerMinute);
    return minutes;
  };

  useEffect(() => {
    const getBlogs = async () => {
      try {
        const blogs = query(collection(db, 'blog'), orderBy('Date', 'desc'));
        const blogsSnapshot = await getDocs(blogs);
        const blogData = blogsSnapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
          imageUrl: doc.data().imageUrl,
        }));

        setAllBlogs(blogData);

        const firstThree = blogData.slice(0, 3);
        setPopBlogs(firstThree);

        setBlogs(blogData.slice(0, blogsPerPage));
      } catch (e) {
        console.error("Error fetching data", e);
      }
    };

    const getFeaturedBlog = async () => {
      try {
        const sblogDoc = await getDoc(doc(db, "blog", featuredId));
        if (sblogDoc.exists()) {
          setFeaturedArticle({ id: sblogDoc.id, ...sblogDoc.data() });
        }
      } catch (e) {
        console.error("Error fetching featured article", e);
      }
    };

    getBlogs();
    getFeaturedBlog();
  }, [featuredId]);

  useEffect(()=>{
    const filteredBlog = selectCategory === 'Others'? allBlogs: allBlogs.filter((blog)=> blog.Category === selectCategory)
    setBlogs(filteredBlog.slice(0, blogsPerPage));
    setCurrentPage(0);
  }, [selectCategory, allBlogs])
  
  // Scroll to top functionality
  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  // Intersection Observer for scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-in-up');
          }
        });
      },
      { threshold: 0.1 }
    );
    
    document.querySelectorAll('.animate-on-scroll').forEach((el) => {
      observer.observe(el);
    });
    
    return () => observer.disconnect();
  }, [blogs]);
  
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNext = () => {
    const nextPage = currentPage + 1;
    const startIndex = nextPage * blogsPerPage;
    const endIndex = startIndex + blogsPerPage;

    if (startIndex < allBlogs.length) {
      setBlogs(allBlogs.slice(startIndex, endIndex));
      setCurrentPage(nextPage);
    }
  };

  const handlePrevious = () => {
    const prevPage = currentPage - 1;
    const startIndex = prevPage * blogsPerPage;
    const endIndex = startIndex + blogsPerPage;

    if (prevPage >= 0) {
      setBlogs(allBlogs.slice(startIndex, endIndex));
      setCurrentPage(prevPage);
    }
  };
  const handleTopicClick = (blogId) => {
    navigate(`/blogs/${blogId}`);
  };
  const handleCategory = (category) =>{
    setSelectedCategory(category)
  }
  
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (value.trim() === '') {
      setBlogs(allBlogs.slice(0, blogsPerPage));
    } else {
      const filtered = allBlogs.filter((blog) =>
        blog.title.toLowerCase().includes(value.toLowerCase()) ||
        getContent(blog).toLowerCase().includes(value.toLowerCase()) ||
        blog.Category.toLowerCase().includes(value.toLowerCase())
      );
      setBlogs(filtered.slice(0, blogsPerPage));
    }
    setCurrentPage(0);
  };
  

  return (
    <>
      <div>
        <div className="welcome-text">
          <h1>
            <b>Welcome to Subin's StoryBoard</b>
          </h1>
          <h1>Discover my stories and follow along !!!</h1>
        </div>

        <Container style={{ marginTop: "100px" }}>
          {featuredArticle && (
          
            <Row className="blog-image-text animate-on-scroll" style={{ alignItems: 'center', opacity: 0, position: 'relative', overflow: 'hidden' }}>
              <Col md={6}>
                <Image 
                  src={featuredArticle.imageUrl} 
                  thumbnail 
                  style={{ 
                    border: 'none', 
                    padding: 0,
                    boxShadow: 'var(--shadow-lg)',
                    borderRadius: '20px',
                    transition: 'transform 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.transform = 'scale(1.03)'}
                  onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                />
              </Col>
              <Col md={6}>
                <div style={{ padding: '20px' }}>
                  <div style={{ 
                    display: 'inline-block',
                    background: 'rgba(102, 126, 234, 0.1)',
                    padding: '4px 12px',
                    borderRadius: '12px',
                    marginBottom: '15px',
                    fontSize: '0.85em',
                    fontWeight: '600',
                    color: 'var(--primary-color)'
                  }}>
                     {calculateReadingTime(getContent(featuredArticle))} min read
                  </div>
                  <h3 style={{ fontSize: '2em', marginBottom: '20px', lineHeight: '1.3' }}>
                    <strong>{featuredArticle.title}</strong>
                  </h3>
                  <p style={{ fontSize: '1.05em', lineHeight: '1.7', opacity: '0.9' }}>
                    {getContent(featuredArticle).length > 60 ? `${getContent(featuredArticle).slice(0, 150)}...` : getContent(featuredArticle)}
                  </p>
                  {getContent(featuredArticle).length > 60 && (
                    <Button 
                      onClick={() => handleTopicClick(featuredArticle.id)} 
                      size="sm"
                      style={{
                        marginTop: '10px',
                        padding: '10px 24px',
                        fontSize: '0.95em'
                      }}
                    >
                      Read more →
                    </Button>
                  )}
                </div>
              </Col>
            </Row>
           
          )
          }
        </Container>

        <Container className="pick-your-choice" style={{ marginTop: '60px' }}>
          <h3 style={{ marginBottom: '30px', textAlign: 'center' }}>Pick up your choice</h3>
          <Row>
            {["Programming", "Life", "Travel", "Others"].map((category) => {
              return (
                <Col sm={3} key={category} style={{ marginBottom: '20px' }}>
                  <div style={{ position: 'relative' }}>
                    <CustomCard 
                      title={category} 
                      backgroundColor="var(--card-bg)" 
                      onClick={() => handleCategory(category)} 
                    />
                  </div>
                </Col>
              );
            })}
          </Row>
        </Container>

        <Container style={{ marginTop: '50px' }}>
          <Row>
            <Col sm={8}>
              <div style={{ marginBottom: '30px' }}>
                <h3 style={{ marginBottom: '20px' }}>Recent Posts</h3>
                <InputGroup className="animate-on-scroll" style={{ maxWidth: '400px' }}>
                  <InputGroup.Text style={{ 
                    background: 'var(--card-bg)', 
                    border: '1px solid var(--border-color)',
                    borderRight: 'none'
                  }}>
                    <FaSearch style={{ color: 'var(--primary-color)' }} />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search posts..."
                    value={searchTerm}
                    onChange={handleSearch}
                    style={{
                      border: '1px solid var(--border-color)',
                      background: 'var(--card-bg)',
                      color: 'var(--body_color)'
                    }}
                  />
                </InputGroup>
              </div>
              {blogs
              .map((blog, index) => (
                <Row className="recent-posts animate-on-scroll" key={index} style={{ alignItems: 'center', opacity: 0 }}>
                  <Col sm={6} style={{ marginBottom: "20px" }}>
                    <div style={{ position: 'relative' }}>
                      <Image 
                        src={blog.imageUrl} 
                        fluid 
                        style={{ 
                          width: "100%", 
                          height: "250px", 
                          objectFit: "cover",
                          borderRadius: '16px',
                          boxShadow: 'var(--shadow-md)'
                        }} 
                      />
                      <div style={{
                        position: 'absolute',
                        top: '12px',
                        right: '12px',
                        background: 'rgba(255, 255, 255, 0.95)',
                        padding: '6px 12px',
                        borderRadius: '20px',
                        fontSize: '0.8em',
                        fontWeight: '600',
                        boxShadow: 'var(--shadow-sm)',
                        backdropFilter: 'blur(10px)'
                      }}>
                         {calculateReadingTime(getContent(blog))} min read
                      </div>
                    </div>
                  </Col>
                  <Col sm={6}>
                    <div>
                      <p style={{ fontSize: '0.9em', marginBottom: '10px' }}>
                        <strong style={{ opacity: '0.8' }}>{blog.Date}</strong> 
                        <strong 
                          style={{ 
                            background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            marginLeft: '18px',
                            fontSize: '0.95em'
                          }}
                        >
                          {blog.Category}
                        </strong>
                      </p>
                      <h3 style={{ fontSize: '1.5em', marginBottom: '15px' }}>{blog.title}</h3>
                      <p style={{ marginBottom: '15px', opacity: '0.85' }}>
                        {getContent(blog).length > 60 ? `${getContent(blog).slice(0, 120)}...` : getContent(blog)}
                      </p>
                      {getContent(blog).length > 60 && (
                        <Button onClick={() => handleTopicClick(blog.id)} size="sm">Read more</Button>
                      )}
                    </div>
                  </Col>
                </Row>
              ))}
              <Container className="post-buttons" style={{ marginTop: '30px' }}>
                <Row className="d-flex justify-content-between">
                  <Col xs="auto">
                    <Button 
                      size="sm" 
                      onClick={handlePrevious}
                      style={{ minWidth: '100px' }}
                    >
                      Previous
                    </Button>
                  </Col>
                  <Col xs="auto">
                    <Button 
                      size="sm" 
                      onClick={handleNext}
                      style={{ minWidth: '100px' }}
                    >
                      Next
                    </Button>
                  </Col>
                </Row>
              </Container>
            </Col>
            <Col sm={4}>
              <div style={{ marginLeft: '40px' }}>
                <h3 style={{ marginBottom: '25px' }}>
                  <strong>What is Hot? 🔥</strong>
                </h3>
                <div style={{ marginTop: '15px' }}>
                  {popblogs.map((blog, index) => (
                    <div 
                      key={index} 
                      style={{ 
                        marginBottom: '30px',
                        padding: '20px',
                        background: 'var(--card-bg)',
                        borderRadius: '16px',
                        border: '1px solid var(--border-color)',
                        boxShadow: 'var(--shadow-sm)',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-5px)';
                        e.currentTarget.style.boxShadow = 'var(--shadow-md)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'var(--shadow-sm)';
                      }}
                    >
                      <TopicBox 
                        title={blog.Category} 
                        color="#FFA500" 
                        style={{ marginBottom: '12px' }} 
                      />
                      <h4 style={{ fontSize: '1.2em', marginBottom: '12px' }}>{blog.title}</h4>
                      <p style={{ fontSize: '0.9em', marginBottom: '15px', opacity: '0.8' }}>
                        <strong>{blog.author.name}</strong>
                        <strong style={{ marginLeft: '12px' }}>{blog.Date}</strong>
                      </p>
                      <Button size="sm" onClick={() => handleTopicClick(blog.id)}>Read more</Button>
                    </div>
                  ))}
                </div>
                <h4 style={{ marginTop: '40px', marginBottom: '20px' }}>
                  <strong>Discover your Interests</strong>
                </h4>
                <div 
                  style={{ 
                    display: 'flex', 
                    flexWrap: 'wrap',
                    gap: '8px'
                  }}
                >
                  <TopicBox title="Coding" color="#c7d2fe"  />
                  <TopicBox title="Life" color="#bbf7d0"  />
                  <TopicBox title="Travel" color="#fce7f3"  />
                  <TopicBox title="Football" color="#fed7aa" />
                  <TopicBox title="Education" color="#bfdbfe"/>
                  <TopicBox title="Tech" color="#fecaca"  />
                </div>
                <h4 style={{ marginTop: '40px', marginBottom: '20px' }}>
                  <strong>About Author</strong>
                </h4>
                <Container 
                  style={{
                    background: 'var(--card-bg)',
                    padding: '20px',
                    borderRadius: '16px',
                    border: '1px solid var(--border-color)',
                    boxShadow: 'var(--shadow-sm)'
                  }}
                >
                  <Row className="align-items-center">
                    <Col sm={5} className="text-center">
                      <Image 
                        src={Author} 
                        roundedCircle 
                        style={{
                          borderRadius: "50%", 
                          width: "90px", 
                          height: "90px", 
                          objectFit: "cover",
                          border: '3px solid var(--primary-color)',
                          boxShadow: 'var(--shadow-md)'
                        }} 
                      />
                    </Col>
                    <Col sm={7}>
                      <h5 style={{ marginBottom: '8px', fontWeight: '700' }}>Subin Bista</h5>
                      <p style={{ marginTop: '5px', fontSize: '0.9em', opacity: '0.85', lineHeight: '1.5' }}>
                        CS student interested in documentation of journey of life.
                      </p>
                    </Col>
                  </Row>
                </Container>
              </div>
            </Col>
          </Row>
        </Container>
        
        {/* Back to Top Button */}
        {showBackToTop && (
          <button
            onClick={scrollToTop}
            style={{
              position: 'fixed',
              bottom: '30px',
              right: '30px',
              width: '50px',
              height: '50px',
              borderRadius: '50%',
              background: 'var(--gradient-primary)',
              color: 'white',
              border: 'none',
              boxShadow: 'var(--shadow-lg)',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.2em',
              transition: 'all 0.3s ease',
              zIndex: 1000,
              animation: 'fadeInUp 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-5px)';
              e.target.style.boxShadow = 'var(--shadow-xl)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'var(--shadow-lg)';
            }}
          >
            <FaArrowUp />
          </button>
        )}
      </div>
    </>
  );
}

export default Home;
